import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Typography, Spin } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useStoreVsVillagePages from '../useInvoicesSalesCompetitors';
import LineChart from '../../../charts/lineChart';
import AlertMessage from '../../../components/alertMessage';
import Helpers from '../../../../../helpers';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    summary,
    loading,
    handleDownloadExcel,
    title,
    searchParams,
    format,
    loadingPdf,
    handleDownloadPdf,
    errors,
  } = useStoreVsVillagePages();
  const { t } = useTranslation();

  const byCompany = searchParams.get('by_company');
  const byPeriod = searchParams.get('by_period');
  const byShoppingCenter = searchParams.get('by_shopping_center');

  return (
    <>
      <PageHeader title={'SALES TREND: STORE vs COMPETITORS'}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Button
              loading={loadingPdf}
              onClick={() => handleDownloadPdf(title)}
              big
              icon={<PlusOutlined />}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <br />
        <AlertMessage
          errors={errors}
          errorText={data.errorText}
          searchParams={searchParams}
          shopRequired
        />
        {byCompany && byPeriod && byShoppingCenter && (
          <Spin spinning={loading}>
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
            </Row>
            <Row>
              <Col xs={24} xxl={12}>
                <Table
                  columns={columns}
                  dataSource={data.tableData}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 500 }}
                  summary={summary}
                  loading={loading}
                />
              </Col>
              <Col xs={24} xxl={12}>
                <LineChart
                  formatTooltip={(v) => Helpers.changeDotToComa(format(v))}
                  data={data.lineChartData}
                  tableData={data.tableData}
                  colors={['#61cdbb', '#f47560', '#e8a838']}
                  itemWidth={150}
                  format={format}
                />
              </Col>
            </Row>
          </Spin>
        )}
      </div>
    </>
  );
};

export default MainPage;
